import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageDataAccess } from '@softline/core';
import { SOFTLINE_CONST_WWS_CASH_REGISTER_CONFIG_KEY } from '../pos.const';

export const configuredGuard: CanActivateFn = (route, r) => {
  const router = inject(Router);
  const storage = inject(LocalStorageDataAccess);

  const config = storage.get({ key: SOFTLINE_CONST_WWS_CASH_REGISTER_CONFIG_KEY });

  if (r.url.includes('pos/config')) return false;

  if (!config) {
    const configPath = router.parseUrl('/pos-config');
    return new RedirectCommand(configPath, {
      skipLocationChange: true,
    });
  } else {
    return true;
  }
};
